import '../App.css';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import LicensingHero from '../components/licensing/LicensingHero';
import DeploymentDiagram from '../components/licensing/DeploymentDiagram';
import ValuePillars from '../components/licensing/ValuePillars';
import Segments from '../components/licensing/Segments';
import IncludedTable from '../components/licensing/IncludedTable';
import BringYourOwn from '../components/licensing/BringYourOwn';
import ProcessSteps from '../components/licensing/ProcessSteps';
import LicensingFaq from '../components/licensing/LicensingFaq';
import ContactBlock from '../components/licensing/ContactBlock';

const TITLE = 'Katbot Licensing — Self-host AI trading intelligence in your own cloud';
const DESCRIPTION =
  'License the Katbot platform and deploy it in your own cloud. Your infrastructure, your keys, your builder code, your brand. Email us for details.';
const URL = 'https://katbot.ai/licensing';

// NOTE: og:image still points at the shared site image. A licensing-specific
// og-image-licensing.png (1200x630, the boundary diagram on dark) is outstanding.
const OG_IMAGE = 'https://katbot.ai/og-image.png';

export const Licensing = () => (
  <div className="text-white">
    <Helmet>
      <title>{TITLE}</title>
      <meta name="description" content={DESCRIPTION} />
      <link rel="canonical" href={URL} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={URL} />
      <meta property="og:title" content={TITLE} />
      <meta property="og:description" content={DESCRIPTION} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={TITLE} />
      <meta name="twitter:description" content={DESCRIPTION} />
      <meta name="twitter:image" content={OG_IMAGE} />
      {/* No `offers` — there is no price on this page. */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Product',
          name: 'Katbot Licensing',
          url: URL,
          category: 'Trading platform software license',
          description:
            'A single-tenant license of the Katbot agentic trading platform — API, agents, risk engine and web front end — deployed in the licensee’s own cloud under their own brand, keys and Hyperliquid builder code.',
          brand: {
            '@type': 'Organization',
            name: 'Katbot',
            url: 'https://katbot.ai',
          },
          manufacturer: {
            '@type': 'Organization',
            name: 'DeepOrb Labs LLC',
            url: 'https://deeporblabs.com',
          },
        })}
      </script>
    </Helmet>

    <div className="mx-auto w-full">
      {/* Hero and diagram share one visual block — no divider between them. */}
      <LicensingHero />
      <div className="mx-auto w-full max-w-6xl px-6 pb-16 pt-8">
        <DeploymentDiagram />
      </div>

      <ValuePillars />
      <Segments />
      <IncludedTable />
      <BringYourOwn />
      <ProcessSteps />
      <LicensingFaq />
      <ContactBlock />
    </div>
  </div>
);

export default Licensing;
